//istanbul ignore file todo CD-50467
import * as React from 'react';

import { IAgentSchema, IOfferSchema, IPhoneSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getOfferTitle, getSquareInformation } from '../../../../utils/offer_helpers';
import { FavoriteButtonContainer } from '../../../favorite_button/container';
import { trackClickFavorite, trackShowPhones } from './tracking';

import * as styles from './index.css';
import { ABCallButton } from '../../../ab_call_button';
import { DynamicCalltrackingButton, EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { formatNumber } from '../../../../utils/phone';

export interface IFullScreenControlsCommonProps {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  abGroup: number;
  user: IUserSchema | null;
  kpId: number | null;
  siteBlockId: number | null;
  newbuildingId: number | null;
  isAuthenticated: boolean;
  price: string | null;
  dynamicCalltrackingPlaceType: string;
}

export interface IFullScreenControlsOwnProps {
  exitFullscreen(): void;
}

export interface IFullScreenControlsDispatchProps {
  setPhoneCollapse(): void;
}

export interface IFullscreenControlsState {
  showPhones: boolean;
}

type IFullScreenControlsProps = IFullScreenControlsCommonProps &
  IFullScreenControlsDispatchProps &
  IFullScreenControlsOwnProps;

export class FullScreenControls extends React.Component<IFullScreenControlsProps, IFullscreenControlsState> {
  public constructor(props: IFullScreenControlsProps) {
    super(props);

    this.state = {
      showPhones: false,
    };
  }

  public showPhones = async () => {
    const { abGroup, agent, offer, user, kpId } = this.props;

    trackShowPhones(offer, agent, user, abGroup, kpId);

    this.props.setPhoneCollapse();
    this.setState({ showPhones: true });
  };

  public render() {
    const { showPhones } = this.state;
    const { offer, siteBlockId, dynamicCalltrackingPlaceType } = this.props;
    const { phones } = offer;

    const phonesAvailable = phones && !phones.some(phone => !phone.countryCode || !phone.number);
    const formattedPhones = phonesAvailable ? (phones as IPhoneSchema[]).map(formatNumber).join(', ') : '';

    return (
      <div className={styles['controls']}>
        {
          <div className={styles['title']}>
            {getOfferTitle(this.props.offer)}, {getSquareInformation(this.props.offer)}, {this.props.price}
          </div>
        }

        {phonesAvailable && (
          <DynamicCalltrackingButton
            isOpen={showPhones}
            blockId={siteBlockId}
            phone={formattedPhones}
            openPhoneClassName={styles['phone']}
            className={styles['show-phone']}
            placeType={dynamicCalltrackingPlaceType}
            onClick={this.showPhones}
            announcementId={offer.id}
            platformType={EPlatformTypes.WebDesktop}
            pageType={EPageTypes.OfferCard}
          >
            <ABCallButton />
          </DynamicCalltrackingButton>
        )}

        <FavoriteButtonContainer
          customClass={styles['favorites']}
          isFullscreenGallary
          onClick={() => {
            trackClickFavorite(this.props.offer, this.props.agent);
          }}
        />

        <div className={styles['close']} onClick={this.props.exitFullscreen} />
      </div>
    );
  }
}
